import { useHook } from '../lenteHooks'

export const useLegalentityLatestEntityVersion = () => {
  const tenantId = useHook('routing.tenant.useTenantParam')()

  const { companyId } = useHook('routing.company.useCompanyParams')({
    isOptional: true,
  })
  const { data: companyVersion } = useHook(
    'fetchers.crm.useFetchCompanyVersionLatest',
  )(companyId ? { tenantId, companyId } : null)

  const { ownerId } = useHook('routing.general.useEntityParams')({
    isOptional: true,
  })
  const { data: personVersion } = useHook(
    'fetchers.crm.useFetchPersonVersionLatest',
  )(ownerId ? { tenantId, personId: ownerId } : null)

  return companyId ? companyVersion : personVersion
}
